
import NavBar from './NavBar/NavBar';
import '../Page1/Page1.css'
import Left from './Left/Left';
import Right from './Right/Right';
import Bottom from './Bottom/Bottom';
export default function Page1(){
    return <div className='mainPage1'>
    <div className='item1'><NavBar/></div>
    <div  className='item2'><Left/></div>
    <div  className='item3'><Right/></div>
    <div  className='item4'><Bottom/></div>
    </div>
}